import { slot_games } from "../../constants/slot_games.js";
import {lastJackpotWinner} from "../../js/api/jackpot.js"
import IframeModal from "../components/IframeModal.js";

let Slots = {
  render: async () => {

    const lastJackpotWinnerLabel = await lastJackpotWinner();
    let view = /*html*/ `
          <div class="machineBoxesHolder" style="overflow-x: auto;">
              <div class="machineBox firstItem" game="BookofRaMagic">
                  <div class="machineItem">
                      <img src="img/book-of-ra-deluxe_tile.png" alt="" />
                      <img src="img/book-of-ra-deluxe_screenshot.jpg" alt="" />
                  </div>
                  <span>Book of Ra Magic</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="FourLuckyClover">
                  <div class="machineItem">
                      <img src="img/FourLuckyClover_tile.png" alt="" />
                      <img src="img/FourLuckyClover_screenshot.jpg" alt="" />
                  </div>
                  <span>Four Lucky Clover</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="40SuperHot">
                  <div class="machineItem">
                      <img src="img/redhotfruits_tile.png" alt="" />
                      <img src="img/redhotfruits_screenshot.jpg" alt="" />
                  </div>
                  <span>40 Super Hot</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
              <div class="machineBox" game="SizzlingHotDeluxe">
                  <div class="machineItem">
                      <img src="img/sizzlinghot_tile.png" alt="" />
                      <img src="img/sizzlinghot_screenshot.jpg" alt="" />
                  </div>
                  <span>Sizzling Hot Deluxe</span>
                  <svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"/></g></svg>
              </div>
          </div>
        </div>
        <div class="slotsCatHolder">
            <div class="slotsCatHelper" id="slotsCatBtn">
            </div>
       </div>
       <div class="slotsMainWrapper">
          <script type="text/javascript" src="http://ajax.googleapis.com/ajax/libs/jquery/1.11.1/jquery.min.js"></script>
          <script type="text/javascript" src="http://ajax.googleapis.com/ajax/libs/swfobject/2.2/swfobject.js"></script>
          <script type="text/javascript">

          </script>
          <div id="main">
            <!--Game selector will be displayed here -->
          </div>
          <div id="overlay"></div>
          <iframe id="iframeSlot" src="" ></iframe>
          <div id="game_container">
            <div id="game_flash"></div>
          </div>
       </div>
       `;
    return view;
  },
  after_render: async () => {
    if(!$('body').hasClass('bg-black')) {
      $("body").addClass("bg-black");
    }

    jackpotMainAnimation();
    jackpotSecondAnimation();
    jackpotThirdAnimation();

    setInterval(jackpotMainAnimation, $('.jackpotMain .light').length * 75);
    setInterval(jackpotSecondAnimation, $('.jackpotSecond .light').length * 70);
    setInterval(jackpotThirdAnimation, $('.jackpotThird .light').length * 70);


    function jackpotMainAnimation(){
      $('.jackpotMain .light').each(function(i, el) {
        setTimeout(function() {
          $(el).addClass('active');
          setTimeout(function() {
            $(el).removeClass('active');
          }, 155);
        }, i * 70);
      });
    }
    function jackpotSecondAnimation(){
      $('.jackpotSecond .light').each(function(i, el) {
        setTimeout(function() {
          $(el).addClass('active');
          setTimeout(function() {
            $(el).removeClass('active');
          }, 155);
        }, i * 70);
      });
    }
    function jackpotThirdAnimation(){
      $('.jackpotThird .light').each(function(i, el) {
        setTimeout(function() {
          $(el).addClass('active');
          setTimeout(function() {
            $(el).removeClass('active');
          }, 155);
        }, i * 70);
      });
    }

    $('body .machineBoxesHolder').slick({
        dots: false,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        centerMode: true,
        variableWidth: true,
        dots: false,
        prevArrow: false,
        nextArrow: false,
        centerPadding: '20px',
    });


    var mainIndex = 0;
    let groupContent = "";

    for (let index = 0; index < slot_games.length; index++) {
      let content = "";
      const element = slot_games[index];
      for (let i = 0; i < element.Data.length; i++) {
        const e = element.Data[i].name;
        const id = element.Data[i].id ? element.Data[i].id : element.Data[i].name;
        // content += `<div class="game" familyid="${element.Type}" game="${e}"><span>${e}</span></div>`;
        content += `<div class="game animation-element" game="${id}"><img src="./img/games_icons/${id}.jpg" onerror="javascript:this.src='./img/games_icons/duser.jpg'"><span>${e}</span><svg xmlns="http://www.w3.org/2000/svg" id="Capa_1" enable-background="new 0 0 512 512" height="18" viewBox="0 0 512 512" width="18"><g><path d="m376 31c-54.544 0-95.017 33.497-120 81.015-24.981-47.515-65.454-81.015-120-81.015-78.609 0-136 66.015-136 146.515 0 106.457 101.572 173.291 246.122 299.773 5.657 4.949 14.099 4.948 19.756 0 144.417-126.366 246.122-193.303 246.122-299.773 0-80.513-57.4-146.515-136-146.515zm-120 415.101c-133.122-115.635-226-179.872-226-268.586 0-66.424 45.57-116.515 106-116.515 58.252 0 94.351 53.947 105.542 93.996 4.036 14.61 24.83 14.675 28.916 0 11.043-39.518 46.723-93.996 105.542-93.996 60.43 0 106 50.091 106 116.515 0 88.765-93.03 153.083-226 268.586z"></path></g></svg></div>`;
        // content += `<div class="game" game="${id}"><img src="/bettting_app/user/src/img/games_icons/${id}.jpg" /><span>${e}</span></div>`;
      }

      if (mainIndex == 0) {
        $("body #slotsCatBtn").append(
          `<div class="groupFamilyBtn active" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
        );
        groupContent += `<div class="groupGame active ${element.Type}">${content}</div>`;
      } else {
        if (element.Type !== "GAMINATOR-NOVOMATIC"){
          $("body #slotsCatBtn").append(
              `<div class="groupFamilyBtn" data-btn-target="${element.Type}"><span class="">${element.Type}</span></div>`
          );
          groupContent += `<div class="groupGame ${element.Type}">${content}</div>`;
        }
      }

      mainIndex++;
    }

    let catLengthWidth = 0;
    $(".groupFamilyBtn ").each(function (e) {
      catLengthWidth += $(this).outerWidth();
    });
    $("body .slotsCatHelper").css({
      width: catLengthWidth + 3 + "px",
    });

    $("#main").html(groupContent);


    $("body").on("click", ".groupFamilyBtn", function (e) {
      let eventTarget = $(e.currentTarget).attr("data-btn-target");
      console.log(eventTarget);
      $("body .groupFamilyBtn").removeClass("active");
      $("body .groupGame").removeClass("active");
      $(e.currentTarget).addClass("active");
      $("body ." + eventTarget + "").addClass("active");
    });

    $("body").on("click", ".machineBox", function (e) {
      if (!localStorage.getItem("access_token") || localStorage.getItem("access_token") == '') {
        alert('Login!');
        return;
      }
      const gameName = $(e.currentTarget).attr("game");
      const gameLink = `http://${location.host}/casino/index?game=${gameName}&u=${localStorage.getItem(
        "access_token"
      )}`;
      // IframeModal.loadIframe(gameLink);
      // IframeModal.show(gameName);
      // window.location.href = gameLink;
      IframeModal.loadIframe(gameLink);
      IframeModal.show(gameName);
    });

    $("body").on("click", ".game", async function (e) {
      if (!localStorage.getItem("access_token") || localStorage.getItem("access_token") == '') {
        alert('Login!');
        return;
      }
      if (localStorage.getItem('username') == 'Ardi91' || localStorage.getItem('username') == 'Gjakova04') {
        return;
      }
      $(e.currentTarget).addClass('clicked');
      setTimeout(function(){
        const gameName = $(e.currentTarget).attr("game");
        const gameLink = `http://${location.host}/casino/index?game=${gameName}&u=${localStorage.getItem(
          "access_token"
        )}`;
        // console.log(gameLink);
        window.location.href = gameLink;
        
        // IframeModal.loadIframe(gameLink);
        // IframeModal.show(gameName);
        $(e.currentTarget).removeClass('clicked');
      },2000);


      // IframeModal.loadIframe(gameLink);
      // IframeModal.show(gameName);

      // var win = window.open(
      //   ``,
      //   "_blank"
      // );
      // if (win) {
      //   //Browser has allowed it to be opened
      //   win.focus();
      // } else {
      //   //Browser has blocked it
      //   alert("Please allow popups for this website");
      // }

    });
  },
};


export default Slots;
